var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 48,
    viewBox: "0 0 61 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_6966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V48H61V0H0ZM58.4593 45.4714H2.54067V2.52184H58.4593V45.4714Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08154 5.05048V42.9461H55.9154V5.05048H5.08154ZM53.3748 40.4243H7.62221V7.57572H53.3748V40.4243Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1626 10.1044V37.8922H50.8338V10.1044H10.1626ZM48.2932 35.367H12.7067V12.6296H48.2966V35.367H48.2932Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2476 15.1548V32.8383H45.7561V15.1548H15.2476ZM43.2154 30.3131H17.7916V17.6835H43.212V30.3131H43.2154Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.332 20.2087V27.7879H40.6642V20.2087H20.332ZM38.1236 25.2626H22.8727V22.734H38.1236V25.2626Z",
    fill: "#2D333C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_6966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon3);
export default __webpack_public_path__ + "static/media/home_icon3.b8f6228212e3eb7e95812c9146321eb6.svg";
export { ForwardRef as ReactComponent };